module.exports = __webpack_public_path__ + "img/bathroom-m.0ab92243.jpg";